export default __webpack_public_path__ + "static/media/victoriaImg.5ec5731d.png";